// extracted by mini-css-extract-plugin
export default {"container":"AdaptiveInput_container__YRB1o","input":"AdaptiveInput_input__0YZ3B","defaultStyles":"AdaptiveInput_defaultStyles__F9Ps-","value":"AdaptiveInput_value__u-9CD"};